<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 32 32"
    fill="none"
    stroke="currentColor"
    stroke-width="2.2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <circle
      cx="16"
      cy="16"
      r="11"
      fill="currentColor"
      fill-opacity=".18"
      stroke="currentColor"
    />
    <path d="M10 16h12" />
  </svg>
</template>

<script>
export default {
  name: 'IconIntentNoAnswer',
  props: { size: { type: [String, Number], default: 22 } },
};
</script>
